import { api, setAccessToken, getAccessToken, ApiError } from './client';
import type { AuthResponse, User } from '../features/auth/types';
export { setAccessToken, getAccessToken };
export type { AuthResponse, User } from '../features/auth/types';

export async function login(email: string, password: string): Promise<AuthResponse> {
  const data = await api.post<AuthResponse>('/api/auth/login', { email, password });
  setAccessToken(data.accessToken);
  return data;
}

export async function register(params: {
  email: string;
  password: string;
  name: string;
  phone?: string;
  role?: string;
}): Promise<AuthResponse> {
  const data = await api.post<AuthResponse>('/api/auth/register', params);
  setAccessToken(data.accessToken);
  return data;
}

export async function refresh(): Promise<AuthResponse> {
  const data = await api.post<AuthResponse>('/api/auth/refresh');
  if (data?.accessToken) setAccessToken(data.accessToken);
  return data;
}

/** Admin-only: create a user with a specific role. Requires admin; only Admin role may be assigned. */
export async function createUserAsAdmin(params: {
  email: string;
  password: string;
  name: string;
  phone?: string;
  roleId: string;
}): Promise<{ user: User }> {
  return api.post<{ user: User }>('/api/auth/admin/create-user', params);
}

export async function logout(): Promise<void> {
  try {
    await api.post('/api/auth/logout');
  } catch {
    // ignore
  }
  setAccessToken(null);
}

export function isAuthError(e: unknown): boolean {
  return e instanceof ApiError && (e.status === 401 || e.status === 409);
}
